import { apiRequest } from './client';

const CUSTOMER = '/api/v1/billing/credits';
const ADMIN = '/api/v1/admin/credits';

const TOKEN_KEY = 'policyora_token';
function authOpts(extra: RequestInit = {}): RequestInit {
  const token = localStorage.getItem(TOKEN_KEY);
  return {
    ...extra,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(extra.headers ?? {}),
    },
  };
}

export interface CreditPurchase {
  id: number;
  kind: 'checkout' | 'auto';
  status: 'pending' | 'paid' | 'failed';
  amount_usd: number;
  credits: number;
  created_at: string | null;
  paid_at: string | null;
}

export interface AutoReload {
  enabled: boolean;
  threshold_usd: number | null;
  reload_usd: number | null;
  has_card: boolean;
  failed_at: string | null;
}

export interface CreditOverview {
  rate_credits_per_usd: number;
  custom_min_usd: number;
  presets_usd: number[];
  min_recharge_usd: number;
  balance: {
    unlimited: boolean;
    enforced: boolean;
    allowance: number | null;
    allowance_remaining: number | null;
    purchased_remaining: number;
    remaining: number | null;
    resets_at: string;
  };
  auto_reload: AutoReload;
  purchases: CreditPurchase[];
}

export interface CreditSettings {
  rate_credits_per_usd: number;
  custom_min_usd: number;
  presets_usd: number[];
}

export const fetchCredits = () => apiRequest<CreditOverview>(CUSTOMER, authOpts());

export const startCreditCheckout = (amount_usd: number) =>
  apiRequest<{ url: string; purchase_id: number; credits: number; amount_usd: number }>(
    `${CUSTOMER}/checkout`,
    authOpts({ method: 'POST', body: JSON.stringify({ amount_usd }) }),
  );

export const saveAutoReload = (patch: { enabled: boolean; threshold_usd?: number; reload_usd?: number }) =>
  apiRequest<AutoReload>(`${CUSTOMER}/auto-reload`, authOpts({ method: 'PUT', body: JSON.stringify(patch) }));

export const adminCreditSettings = () => apiRequest<CreditSettings>(`${ADMIN}/settings`, authOpts());

export const adminSaveCreditSettings = (patch: Partial<CreditSettings>) =>
  apiRequest<CreditSettings>(`${ADMIN}/settings`, authOpts({ method: 'PUT', body: JSON.stringify(patch) }));

/** A refused request carries the reason in ``detail.message``; show that, not a generic error. */
export function refusalMessage(err: unknown, fallback: string): string {
  const e = err as { message?: string; detail?: { message?: string } } | undefined;
  return e?.detail?.message || e?.message || fallback;
}
